
  <!--<printheaderview></printheaderview>-->
  

  <div class="row">
    <div class="col-print-12 padding-left-0px padding-right-0px">
      <div class="card background-color-wt">
        <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

          <div class="row">
            <div class="col-print-12 text-align-center">
              <label class="font-familyhead">Embryo Transfer</label>
              <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style3" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->
            </div>
          </div>

          <div class="col-print-12 padding-left-0px padding-right-0px bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 padding-left-0px padding-right-0px margin-top-10 margin-bottom-10px">
                <!--<div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PatientId}}</label>
                  </div>
                </div>-->
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolStart | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorData}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 padding-left-0px padding-right-0px margin-top-10 margin-bottom-10px">
                
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                  </div>
                </div>
                
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEnd | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Donor ID:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorCode}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family font-weight-bold">Embryo Transfer Procedure:</label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-5 padding-left-0px padding-right-0px margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-bold">Team</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold"></label>
                  </div>
                </div>

                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Surgeon:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Surgeon}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Asst.Surgeon:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{AsstSurgeon}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Embryologist:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Embryologist}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Anaesthesiologist:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Anaesthesiologist}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Anaesthesia:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Anaesthesia}}</label>
                  </div>
                </div>
              </div>

              <div class="col-print-1"></div>

              <div class="col-print-5 padding-left-0px padding-right-0px margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-bold">Schedule</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold"></label>
                  </div>
                </div>
                <!--<div class="row margin-left-0px margin-right-0px">
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family font-weight-normal">Planned Time:</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal">{{PlannedTime | date:'hh:mm:ss'}}</label>
          </div>
        </div>-->
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Actual Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DSADOC}} {{DSASTIMULATION}} {{DSAANTAG}} ({{ActualDate | date:'dd-MMM-yyyy'}})</label>
                  </div>
                </div>
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Actual Time:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ActualTime | date:'hh:mm:ss'}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <!--<div class="col-md-12">
    <div class="row margin-left-0px">
      <div class="col-md-2">
        <label class="margin-bottom-0px font-family font-weight-normal"></label>
      </div>
      <div class="col-md-6">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family font-weight-bold">Transfer Details:</label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <!--<div class=""></div>-->
          <div class="col-print-12 padding-left-0px padding-right-0px bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px">
              <div class="col-print-5 padding-left-0px padding-right-0px margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Type of Transfer:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{TypeOfTransfer}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Culture Media Used:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{CultureMedia}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Thawing Media Used:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">{{ThawingMedia}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Catheter Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CatheterType}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Media Cleaning of Cervical Canal:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CervicalCleaning}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Day of Transfer:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DayOfTransfer}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Speculum Used:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{SpeculumUsed}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Method:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Method}}</label>
                  </div>
                </div>

                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Catheter Used:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CatheterUsed}}</label>
                  </div>
                </div>


              </div>

              <div class="col-print-1 margin-top-10 margin-bottom-10px"></div>

              <div class="col-print-5 padding-left-0px padding-right-0px margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Retained Embryos:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{RetainedEmbryos}}</label>
                  </div>
                </div>
                <!--<div class="row margin-left-0px">
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family font-weight-normal">Fragmentation:</label>
          </div>
          <div class="col-print-6">
            <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Fragmentation}}</label>
          </div>
        </div>-->
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Stilette:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{HasStilette}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Cervical Mucus:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CervicalMucus}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Blood on Catheter:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{BloodOnCatheter}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Technique:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Technique}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Dilator:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{BloodOnCatheter}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Retransfer:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Retransfer}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Embryo Transfer:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{EmbryoTransfer}}</label>
                  </div>
                </div>


              </div>
            </div>
          </div>

          <!--<div class="pagebrkaft"></div>-->
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family font-weight-bold">Embryo Grading</label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <!--<div class="col-print-3"></div>-->
              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          DOC &amp; Date
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          Stage
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Straw#
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Grade
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Transfer Count
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferredController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">[{{l.DOC}}] &amp; {{l.TimeStamp| date:'MMM-dd-yyyy'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Cellstage}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.StrawNumber}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Regrade1}}{{l.Regrade2}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.UsedCount}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--<div class="col-md-12 padding-left-0px padding-right-0px">
    <div class="row margin-left-0px">
      <div class="col-md-2">
        <label class="margin-bottom-0px font-family font-weight-normal"></label>
      </div>
      <div class="col-md-6">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->
          <div class="col-print-11 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal">Notes</label>
              </div>:
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Notes}}</label>
              </div>
            </div>
          </div>
          <div class="pagebrkaft"></div>

          <div class="col-print-12 padding-left-0px padding-right-0px">

            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-normal">Tests:</label>
              </div>
              <div class="col-print-6">
                <div class="row">
                  <div class="col-print-6 padding-left-15px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-2"></div>
              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Test Name
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Result
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.TestName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Result}}{{l.ResultUnits}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="pagebrkaft"></div>-->
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family font-weight-normal">Medicines:</label>
              </div>
              <div class="col-print-6">
                <div class="row">
                  <div class="col-print-6 padding-left-15px">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>

              </div>

            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-2"></div>
              <div class="col-print-10">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero">
                      <tr>
                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          S.No
                        </th>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-left">
                          Medicine Name
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Dose
                        </th>

                      </tr>
                      <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.MedicineName}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.Dosage}} {{l.DurationType}}</td>
                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family">Surgeon</label>
              </div>
              <div class="col-print-4">
                <label class="margin-bottom-0px font-family">Assistant Surgeon</label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12 padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-8">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-7 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center">{{Surgeon}}</label>
                  </div>
                  <!--<div class="col-print-6">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>-->
                </div>
              </div>
              <div class="col-print-4">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-print-12 border-bot-1px">
                    <label class="margin-bottom-0px font-family text-align-center">{{AsstSurgeon}}</label>
                  </div>
                  <!--<div class="col-print-5">
                    <label class="margin-bottom-0px font-family"></label>
                  </div>-->
                </div>
              </div>
            </div>
          </div>

        </div>
        </div>
    </div>
  </div>



  <!--<printfooterview></printfooterview>-->



